// #awards-category: behaves as tabs on desktop (one card always selected, its
// detail shown in the right panel) and as a single-open accordion on mobile
// (tapping the open card collapses it).
const initAwardsCategory = () => {
  const root = document.querySelector('#awards-category')
  if (!root) return

  const items = Array.from(root.querySelectorAll('[data-awards-item]'))
  const triggers = Array.from(root.querySelectorAll('[data-awards-trigger]'))
  if (!triggers.length) return

  const desktopPanels = Array.from(
    root.querySelectorAll('[data-awards-desktop-panel]')
  )
  const desktopMq = window.matchMedia('(min-width: 1024px)')

  let activeIndex = 0

  const render = () => {
    triggers.forEach((trigger) => {
      const index = Number(trigger.dataset.awardsTrigger)
      const isActive = index === activeIndex
      trigger.classList.toggle('is-active', isActive)
      trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false')
      const item = trigger.closest('[data-awards-item]')
      if (item) item.classList.toggle('is-open', isActive)
    })

    desktopPanels.forEach((panel) => {
      const index = Number(panel.dataset.awardsDesktopPanel)
      panel.classList.toggle('hidden', index !== activeIndex)
    })
  }

  const collapseAll = () => {
    activeIndex = -1
    items.forEach((item) => item.classList.remove('is-open'))
    triggers.forEach((trigger) => {
      trigger.classList.remove('is-active')
      trigger.setAttribute('aria-expanded', 'false')
    })
  }

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-awards-trigger]')
    if (!trigger) return
    const index = Number(trigger.dataset.awardsTrigger)

    // On mobile, tapping the already-open card collapses it (accordion).
    if (!desktopMq.matches && index === activeIndex) {
      collapseAll()
      return
    }

    activeIndex = index
    render()
  })

  // Never leave the desktop layout without a selected panel.
  desktopMq.addEventListener('change', (event) => {
    if (event.matches && activeIndex < 0) {
      activeIndex = 0
      render()
    }
  })

  render()
}

export default initAwardsCategory
